export default __webpack_public_path__ + "static/1-8--c9c464d6f934b3e4c6cc27589e0449fe.png";